import axios from 'axios';
import { appConstant } from "@/app.constant";

export const loadAppInsight = () => {
    /* eslint-disable */
    var appInsights = window.appInsights ||function(a){
        function b(a){c[a]=function(){var b=arguments;c.queue.push(function(){c[a].apply(c,b)})}}var c={config:a},d=document,e=window;setTimeout(function(){var b=d.createElement("script");b.src=a.url||"https://az416426.vo.msecnd.net/scripts/a/ai.0.js",d.getElementsByTagName("script")[0].parentNode.appendChild(b)});try{c.cookie=d.cookie}catch(a){}c.queue=[];for(var f=["Event","Exception","Metric","PageView","Trace","Dependency"];f.length;)b("track"+f.pop());if(b("setAuthenticatedUserContext"),b("clearAuthenticatedUserContext"),b("startTrackEvent"),b("stopTrackEvent"),b("startTrackPage"),b("stopTrackPage"),b("flush"),!a.disableExceptionTracking){f="onerror",b("_"+f);var g=e[f];e[f]=function(a,b,d,e,h){var i=g&&g(a,b,d,e,h);return!0!==i&&c["_"+f](a,b,d,e,h),i}}return c
    }({
        //TODO: Key is hardcoded for testing purpose
        instrumentationKey: process.env.VUE_APP_INSIGHT_KEY
    });
    window.appInsights=appInsights,appInsights.queue&&0===appInsights.queue.length&&appInsights.trackPageView();

};
/* eslint-enable */

export const getAxiosCancelTokenSource = () => {
    const cancelToken = axios.CancelToken;
    return cancelToken.source();
};

export const setPostLoginUrl = (url) => {
    const postLoginUrl = url || `${window.location.origin}/#/home`;
    sessionStorage.setItem(appConstant.storageKeys.ypoForwardToPostLogin, postLoginUrl);
};

export const getNextRouteFromUrl = (url) => {
    let nextRoute = "/home";
  if (url.includes(window.location.origin)) {
      // eslint-disable-next-line prefer-destructuring
      nextRoute = url.split(`${window.location.origin}/#`)[1];
  }
  return nextRoute;
};

export const getAuthObject = (authProviderType) => {
    return {
        authProvider: authProviderType || 'okta',
        token: null,
        tokenType: null,
        expTime: null,
        userGuid: null,
    };
};

export const sendForumMessage = async () => {
    const fromUrl = document.location.href;
    if (window && window.appInterface) {
        const androidInterface = window.appInterface;
        androidInterface.navigateToForum(fromUrl);
    } else if (window && window.webkit && window.webkit.messageHandlers) {
        const iosInterface = window.webkit.messageHandlers.navigateToForum;
        iosInterface.postMessage(fromUrl);
    }
};

export const postWebViewInterfaceMessage = (message) => {
    if (window && window.appInterface) {
        const androidInterface = window.appInterface;
        androidInterface.postMessage(message);
    }

    if (window && window.webkit) {
        const iosInterface = window.webkit.messageHandlers.callback;
        iosInterface.postMessage(message);
    }
};

export const getBrowserName = () => {
    if (navigator.userAgent.indexOf("Chrome") !== -1) {
        return "chrome";
    } else if (navigator.userAgent.indexOf("Opera") !== -1) {
        return "0pera";
    } else if (navigator.userAgent.indexOf("MSIE") !== -1) {
        return "ie";
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
        return "firefox";
    } else if (navigator.userAgent.indexOf("Safari") !== -1) {
        return "safari";
    }
    return "unknown";
};
